import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AdSenseLoader from "@/components/AdSenseLoader";
import GA4Loader from "@/components/GA4Loader";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import EventsPage from "@/pages/EventsPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AppShell() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandProvider>
          <BrowserRouter>
            <AdSenseLoader />
            <GA4Loader />
            <AppShell />
            <Toaster theme="dark" position="top-right" richColors />
          </BrowserRouter>
        </BrandProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
